export default {"src":"/_next/static/media/databox.06f5571d.svg","height":244,"width":649,"blurWidth":0,"blurHeight":0};